export default __webpack_public_path__ + "static/media/done.46acaf48.svg";